// extracted by mini-css-extract-plugin
module.exports = {"keyTooltip":"ApiKeys_keyTooltip__3NgO3"};